import React, { Component } from 'react';
import '../components/repayments.css';
import { Gateway } from '../BaseUrl';
import { dateSuffix, dateAndMonth } from '../Functions/Generic';
import { Loading } from './Loading';
import { CollectionsNumber } from './Variables';
import { Get } from '../Ajax';
import { AddCard } from './AddCard/AddCard';

export class Repayments extends Component {
    displayName = Repayments.name
    _isMounted = false;
    constructor(props) {
        super(props);

        this.state = {
            cards: [],
            loadingCards: false
        }

        this.props.changeLogo("card");
        this.getCards = this.getCards.bind(this);        
    }

    async componentDidMount() {
        this._isMounted = true;
        await this.getCards();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    updateState(object, func = () => { }) {
        if (this._isMounted) {
            this.setState(object, func);
        }
    }

    async getCards() {
        try {
            this.setState({
                loadingCards: true
            });

            let data = await Get(`${Gateway}/Payments/CustomerCards`, 'json', () => this.props.Logout(true));

            this.updateState({
                cards: data,
                loadingCards: false
            });
        } catch (e) {
            console.error(e);
        }
    };

    render() {
        const styles = { display: "flex", justifyContent: "space-between" };
        const c = CollectionsNumber.replace(/\s/g, '');
        const {
            loanReferenceNumber,
            currentBalance,
            rmiAmount,
            rmiLastFour,
            nextRmiPaymentDate
        } = this.props;
        return (
            <div className="repayments-page-container" style={{ width: "100%" }}>
                <div className="repaymet-large-details desktop-only">
                    <div className="large-title">
                        <h2 className="text-center"> Repayments </h2>
                    </div>
                    <div className="container large-details">
                        <div className="large-detail">
                            <label>Agreement Number</label>
                            <p>{loanReferenceNumber}</p>
                        </div>
                        <div className="large-detail">
                            <label>Current Balance</label>
                            <p>€{currentBalance.toFixed(2)}</p>
                        </div>
                        <div className="large-detail">
                            <label>Monthly Instalment</label>
                            <p>€{rmiAmount.toFixed(2)}</p>
                        </div>
                    </div>
                </div>
                <div className="container repayments-container">
                    <div className="mobile-only">
                        <h3>Repayments</h3>
                        <div style={styles}>
                            <label>Agreement Number</label>
                            <p>{loanReferenceNumber}</p>
                        </div>
                        <div style={styles}>
                            <label>Current Balance</label>
                            <p>€{currentBalance.toFixed(2)}</p>
                        </div>
                        <div style={styles}>
                            <label>Monthly Instalment</label>
                            <p>€{rmiAmount.toFixed(2)}</p>
                        </div>
                    </div>
                    <hr className="mobile-only" />
                    <div className="grow-1">
                        <h3>Repayment Date</h3>
                        <div>
                            <label>Next payment amount</label>
                            <div>€{rmiAmount.toFixed(2)}</div>
                        </div>
                        <div>
                            <label>Next payment date</label>
                            <div>{dateAndMonth(nextRmiPaymentDate)}</div>
                        </div>
                    </div>
                    <hr className="mobile-only" />
                    <div className="grow-1">
                        <h3>Direct Debit Details</h3>
                        {
                            this.props.summary.rmiLastFour != null ?
                            <div>
                                <div>
                                    <label>Name on account</label>
                                    <div>{this.props.name.title} {this.props.name.firstname} {this.props.name.lastname}</div>
                                </div>

                                <div>
                                    <label>Iban number</label>
                                    <div> #### #### #### {rmiLastFour}</div>
                                </div>
                            </div> :
                            <div>
                                There are no Direct Debt details
                            </div>
                        }
                    </div>
                    <hr className="mobile-only" />
                    <div>
                        <h3>Card Details</h3>
                        {
                            this.state.loadingCards ?
                                <Loading small={true} /> :
                            this.state.cards.map((item, index) => {
                                return (
                                    <div key={index} style={styles}>
                                        <div style={{ display: "flex", alignItems: "center" }}><span style={{ fontSize: "30px" }} className="fas fa-credit-card"></span></div>
                                        <div style={{ flexGrow: "2", paddingLeft: "15px" }}>
                                            <label></label>
                                            <div>{item.cardLastFourDigits != null && "#### #### ####"} {item.cardLastFourDigits}</div>
                                        </div>
                                    </div>
                                )   
                            })
                        }
                        <AddCard {...this.props} isButton={false} text="Add a new card?" onClose={() => this.getCards()} />
                    </div>
                </div>
                <div className="container">
                    <p className="change-detail-info" >To update or delete your bank or card details, please call us on <a className="change-detail-info" href={"tel:" + c}>{CollectionsNumber}</a></p>
                </div>
            </div>
        );
    }
}

Repayments.defaultProps = {
    loanReferenceNumber: 0,
    payoutAmount: 0,
    currentBalance: 0,
    rmiAmount: 0,
    rmiRegularPaymentDay: 0,
    startDate: 0,
    endDate: 0,
    totalRepayment: 0,
    term: 0,
    costPer100Euros: 0
};

const SmlSummary = (props) => {
    <div>
        <div className="large-detail">
            <label>Agreement Number</label>
            <p>{props.summary.loanReferenceNumber}</p>
        </div>
        <div className="large-detail">
            <label>Current Balance</label>
            <p>{props.summary.currentBalance.toFixed(2)}</p>
        </div>
        <div className="large-detail">
            <label>Monthly Instalment</label>
            <p>€{props.summary.rmiAmount.toFixed(2)}</p>
        </div>
    </div>
}


// WEBPACK FOOTER //
// ./src/components/Repayments.js